import moment from "moment"
import { FormTypeAdd } from "utils/Constant"
import { GetStatus } from "utils/helpers"

export const FilterCard = ({ title, children, width }) => {
    const cardWidth = width || "w-full sm:w-72"

    return (
        <div className={`flex flex-col sm:gap-1 ${ cardWidth } text-sm sm:text-base`}>
            <span>{ title }</span>
            { children }
        </div>
    )
}

export const FormCard = ({ title, children, width }) => {
    const cardWidth = width || "w-full sm:w-72"

    return (
        <div className="flex h-18 sm:h-10">
            <div className="flex flex-col sm:flex-row sm:items-center w-full">
                <div className="w-48">
                    <span>{ title }</span>
                </div>
                <div className="px-4 hidden sm:block">
                    <span>:</span>
                </div>
                <div className={` ${cardWidth}`}>
                    { children }
                </div>
            </div>
        </div>
    )
}

export const CreditCardDetailCard = ({ title, children }) => {
    return (
        <div className="flex items-center">
            <div className="w-32 sm:w-48">
                <span className="">{title}</span>
            </div>
            <div className="px-2">
                <span>:</span>
            </div>
            <div>
                <span>{children}</span>
            </div>
        </div>
    )
}

export const PagesTitle = ({ title }) => {
    return (
        <div className="flex flex-col gap-2">
            <div className="flex justify-between">
                <span className="font-semibold text-xl sm:text-xl">{ title }</span>
            </div>
            <hr />
        </div>
    )
}

export const PagesFormTitle = ({ title, formType, status, createDate, updateDate, updateBy }) => {
    return (
        <div className="flex flex-col gap-2">
            <div className="flex justify-between">
                <span className="font-semibold text-xl">{ title }</span>
                <div className={`flex gap-2 items-end justify-end ${ formType === FormTypeAdd ? 'hidden' : 'block'}`}>
                    <span className="text-sm opacity-60">
                        Status : {GetStatus(status)} | Created Date : {moment(createDate).format("DD MMM yyyy")} | Last Updated : {moment(updateDate).format("DD MMM yyyy")} | Updated By : {updateBy}
                    </span>
                </div>
            </div>
            <hr />
        </div>
    )
}